import { DocumentData } from "firebase/firestore";
import { RequestPayoutComponent } from "../../../pages/admin/admin.request-payout";
export function RequestPayout({
  balance = 0,
  eventData,
}: {
  balance: number;
  eventData: DocumentData | null;
}) {
  return (
    <>
      <div
        className='modal fade payout-modal'
        id='request-payout-modal'
        tabIndex={-1}
        aria-labelledby='request-payout-modal-label'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1 className='modal-title fs-5' id='request-payout-modal-label'>
                Request Payout
              </h1>
              <button
                type='button'
                className='bttn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='bi bi-x-circle'></i>
              </button>
            </div>
            <div className='modal-body'>
              <RequestPayoutComponent balance={balance} eventData={eventData} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
